export default __webpack_public_path__ + "static/media/Deloitte.5f348f24.svg";